import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { environment } from '../shared/environments/environment.prod';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class KeycloakService {
  private keycloakInstance: Keycloak;
  private keycloakUrl = environment.urlMapping.DOMAIN_URL;
  private realm = 'ApCrdaUM';
  private clientId = 'apcrdausermgmt';

  constructor() {
    console.log("constrcutor called")
    this.keycloakInstance = new Keycloak({
      url: `${environment.urlMapping.DOMAIN_URL}/auth`,
      realm: this.realm,
      clientId: this.clientId,
    });
  }

  init(): Promise<void> {
    console.log("keycloakInstanceInint called", this.keycloakInstance)
    return this.keycloakInstance
      .init({
        onLoad: 'check-sso',
        checkLoginIframe: false,
      })
      .then((authenticated) => {
        if (authenticated) {
          console.log("User is authenticated via check-sso");
          this.saveTokensToStorage();
          localStorage.setItem('loggedIn', 'true');
        } else {
          // return this.keycloakInstance.login({ redirectUri: window.location.origin });
          console.log("User is not authenticated, skipping auto-login");
        }

        return Promise.resolve();
      })
      .catch((error) => {
        console.error('Keycloak initialization failed', error);
        return Promise.reject(error);
      });
  }

  login(options?: any): Promise<void> {
    return this.keycloakInstance.login(options || { redirectUri: window.location.origin });
  }

  // logout() {
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   this.keycloakInstance.logout({
  //     redirectUri: window.location.origin
  //   });
  // }


  // ✅ POST-based custom logout
  logout(): void {
    const idToken = this.keycloakInstance.idToken;

    if (!idToken) {
      this.forceLocalLogout();
      return;
    }

    const logoutUrl =
      `${this.keycloakUrl}/auth/realms/${this.realm}/custom-logout/logout`;

    const formData = new URLSearchParams();
    formData.append('client_id', this.clientId);
    formData.append('id_token_hint', idToken);
    formData.append('post_logout_redirect_uri', window.location.origin);

    fetch(logoutUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
      credentials: 'include',
    })
      .then((response) => {
        this.clearLocalSession();
        window.location.href = window.location.origin;
      })
      .catch((error) => {
        console.error('Custom logout failed', error);
        this.forceLocalLogout();
      });
  }

  // 🔹 ADD THESE METHODS
  private clearLocalSession(): void {
    this.clearRefreshInterval();
    localStorage.clear();
    sessionStorage.clear();
    this.keycloakInstance.clearToken();
    document.cookie = 'geoportal_token=; path=/geoserver; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Lax; Secure';
  }

  private forceLocalLogout(): void {
    this.clearLocalSession();
    window.location.href = window.location.origin;
  }


  clearToken(): void {
    if (this.keycloakInstance) {
      this.keycloakInstance.clearToken();
      console.log('Token cleared from Keycloak instance');
    } else {
      console.warn('Keycloak instance is not initialized');
    }
  }

  saveTokensToStorage(): void {
    if (this.keycloakInstance.token) {
      localStorage.setItem('token', this.keycloakInstance.token);
      document.cookie = `geoportal_token=${this.keycloakInstance.token}; path=/geoserver; SameSite=Lax; Secure`;
    }
    if (this.keycloakInstance.refreshToken) {
      localStorage.setItem('refreshToken', this.keycloakInstance.refreshToken);
    }
  }

  isLoggedIn(): boolean {
    return !!this.keycloakInstance && !!this.keycloakInstance.authenticated;
  }

  private refreshInterval: any;

  setupTokenMonitoring(): void {
    console.log("this.keycloakInstance::", this.keycloakInstance)
    if (this.keycloakInstance) {
      this.clearRefreshInterval();
      this.refreshInterval = setInterval(() => {
        if (this.keycloakInstance) {
          this.keycloakInstance.updateToken(30)
            .then((refreshed) => {
              if (refreshed) {
                // console.log('Token proactively refreshed');
                this.saveTokensToStorage();
              }
            })
            .catch(() => {
              console.warn('Proactive token refresh failed');
            });
        }
      }, 30000); // Check every 30 seconds

      this.keycloakInstance.onTokenExpired = () => {
        console.warn('Token expired, attempting to refresh');
        this.keycloakInstance
          .updateToken(30)
          .then((refreshed) => {
            if (!refreshed) {
              console.warn('Token not refreshed, logging out');
              this.logout();
            } else {
              console.log('Token refreshed successfully');
              this.saveTokensToStorage();
            }
          })
          .catch((error) => {
            console.error('Failed to refresh the token', error);
            this.logout();
          });
      };
    } else {
      console.warn('Keycloak instance is not initialized for token monitoring');
    }
  }

  private clearRefreshInterval() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  getToken(): Promise<string> {
    if (!this.keycloakInstance) {
      return Promise.reject('Keycloak instance is not initialized');
    }

    return this.keycloakInstance
      .updateToken(30)
      .then(() => {
        const token = this.keycloakInstance.token;
        // const refreshToken = this.keycloakInstance.refreshToken;
        if (!token) {
          return Promise.reject('Token is unavailable');
        }

        this.saveTokensToStorage();

        return token;
      })
      .catch((error) => {
        return Promise.reject('Failed to get a valid token');
      });
  }



  getKeycloakInstance(): Keycloak {
    return this.keycloakInstance;
  }

  isRefreshTokenExpired(): boolean {
    if (!this.keycloakInstance || !this.keycloakInstance.refreshTokenParsed?.exp) {
      return false;
    }
    const timeLocal = Math.round(new Date().getTime() / 1000);
    const timeSkew = this.keycloakInstance.timeSkew || 0;
    return this.keycloakInstance.refreshTokenParsed.exp < (timeLocal + timeSkew);
  }

  getuserInfo() {
    console.log("this.keycloakInstance.tokenParsed", this.keycloakInstance.tokenParsed?.['preferred_username'], localStorage)
    return this.keycloakInstance.tokenParsed?.['preferred_username'];
  }
}
